import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { showToast } from '@/components/ToastManager';
import { LaunchParamsSchema } from '@telegram-apps/transformers';
import { InferOutput } from 'valibot';
export type RetrieveLPResult = InferOutput<typeof LaunchParamsSchema>;

class TgApi {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: import.meta.env.VITE_TG_API_BASE_URL || '/api/v1/tg',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    this.axiosInstance.interceptors.response.use(
      (response: AxiosResponse) => response,
      (error: AxiosError) => {
        showToast('errorToast', 'error', 'Ошибка запроса', error.message);
        return Promise.reject(error);
      }
    );
  }

  public async getAiAnswer(answerUid: string, initDataRaw: any): Promise<string> {
    try {
      const { data } = await this.axiosInstance.get(`/tg_ai/answers/${answerUid}`, {
        headers: {
          Authorization: `tma ${initDataRaw}`
        }
      });
      return data;
    } catch (error) {
      console.error('Error getting ai answer:', error);
      throw new Error('Error getting ai answer');
    }
  }
}

export default new TgApi();
